module.exports = __webpack_public_path__ + "assets/img/33@3x.98da58c6.png";